import { ReactElement } from 'react'
import styled from 'styled-components'
import { I18n } from 'common'
import { defaultTheme } from '../theme/index'
import EulaDailog from '../features/login/EulaDailog'
import { show as showNiceModal } from '@ebay/nice-modal-react'

declare const __COMMIT_HASH__: string
function Footer(): ReactElement {
  const currentYear = new Date().getFullYear()
  return (
    <Container>
      <div className="row">
        <div className="col-md-7 col-12">
          <div>
            &copy; 2006-{currentYear}{' '}
            <I18n name="aftermarketAutoPartsAlliance" />;{' '}
            <I18n name="allRightsReserved" />
          </div>
        </div>
        <div className="col-md-3 col-12 text-md-end">
          <Subtitle
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              showNiceModal(EulaDailog)
            }}
          >
            <I18n name="endUserLicenseAgreement" />
          </Subtitle>
        </div>
        <div className="col-md-2 col-12 text-md-end">
          <VersionNumber>{__COMMIT_HASH__}</VersionNumber>
        </div>
      </div>
    </Container>
  )
}

export default Footer

const Container = styled.div`
  padding: 10px 20px;
  background: ${defaultTheme.colors.rowFeaturedBackground};
  box-shadow: 0px -5px 8px 0px rgba(0, 0, 0, 0.1);
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  @media print {
    display: none;
  }
`

const Subtitle = styled.a`
  text-decoration: underline;
  cursor: pointer;
  color: ${defaultTheme.colors.almostBlack};
  &:hover {
    opacity: 0.8;
  }
  &:active {
    opacity: 0.5;
  }
`

const VersionNumber = styled.div`
  color: ${defaultTheme.colors.almostBlack};
  font-weight: 700;
`
